export default "__VITE_ASSET__DMooSgUv__"